import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { capturePlannerHandoff } from './planner-handoff';
import '@240tutoring/labs-ui/labs-nav.css';
import './styles.css';
import { reloadOnStaleAssets } from '../../../shared/stale-assets';

// First, before Clerk or PostHog read the address bar: hold a Planner hand-off and send
// /from-planner#… to / (KTD4).
capturePlannerHandoff();
// TopicReader loads on demand; after a deploy an open tab may ask for a file that is gone.
reloadOnStaleAssets();
createRoot(document.getElementById('root')!).render(<StrictMode><App /></StrictMode>);
